export default {
    /* GET_MATERIAL_RESERVATIONS_SUCCESS
    ---------------------------------------------------------------
    */
    GET_MATERIAL_RESERVATIONS_REQUEST: state => {
        state.materialReservationsLoading = true
    },
    GET_MATERIAL_RESERVATIONS_SUCCESS: (state, data) => {
        state.materialReservations = data.results
        state.materialReservationsLoading = false
    },
    GET_MATERIAL_RESERVATIONS_FAILURE: state => {
        state.materialReservationsLoading = false
    },
    /* SET_MATERIAL_RESERVATIONS_FILTERS
    ---------------------------------------------------------------
    */
    SET_MATERIAL_RESERVATIONS_FILTERS: (state, filters) => {
        state.filters = filters
    },
    CLEAR_MATERIAL_RESERVATIONS_FILTERS: state => {
        state.filters = state.setInitialFilters()
    },
}